<template>
  <form class="seat-picker-form">
    <div class="iw-layout-grid__row iw-layout-grid-form__row">
      <levels-selector class="seat-select iw-layout-grid__col--span-3-desktop iw-layout-grid__col--span-2-phone" />
      <sections-selector class="seat-select iw-layout-grid__col--span-3-desktop iw-layout-grid__col--span-2-phone" />
      <rows-selector class="seat-select iw-layout-grid__col--span-3-desktop iw-layout-grid__col--span-2-phone" />
      <seat-selector class="seat-select iw-layout-grid__col--span-3-desktop iw-layout-grid__col--span-2-phone" />
    </div>
    <app-button
      class="seat-picker-form__button"
      :text="'Continue'"
      :aria-label="'Continue'"
      :handler="selectSeat"
      :is-disabled="!isValid || !isSelectionValid"
    >
    </app-button>
  </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SectionsSelector from "./sections-selector/SectionsSelector";
import LevelsSelector from "./levels-selector/LevelsSelector";
import RowsSelector from "./rows-selector/RowsSelector";
import SeatSelector from "./seat-selector/SeatSelector";

export default {
  name: "SeatPickerForm",
  components: { SeatSelector, RowsSelector, LevelsSelector, SectionsSelector },
  props: {
    seatSelected: Function
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      isValid: "level/isValid",
      isFullCart: "cart/getCartSize",
      selectedLevel: "delivery/getSelectedLevel",
      selectedSection: "delivery/getSelectedSection",
      selectedRow: "delivery/getSelectedRow",
      selectedSeat: "delivery/getSelectedSeat"
    }),
    isSelectionValid() {
      return this.isLevelValid && this.isSectionValid && this.isRowValid && this.isSeatValid;
    },

    isLevelValid() {
      return this.selectedLevel.id ? true : false;
    },
    isSectionValid() {
      return this.selectedSection.id ? true : false;
    },
    isRowValid() {
      return this.selectedRow.id ? true : false;
    },
    isSeatValid() {
      return this.selectedSeat.id ? true : false;
    }
  },
  methods: {
    ...mapActions({
      fetchLocationVendors: "level/fetchLocationVendors"
    }),
    selectSeat() {
      this.fetchVendors();
    },
    fetchVendors() {
      return this.fetchLocationVendors().then(() => {
        return this.seatSelected(this.isFullCart);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.dark {
  .seat-picker-form {
    background-color: $background-dark--2;
  }
}

.seat-picker-form {
  margin-top: -8px;
  width: 100%;
  @include respond-to-mobile {
    margin-top: 0px;
    box-sizing: border-box;
  }
  &__button {
    max-width: 343px;
    margin: auto;
    margin-top: 60px;
    @include respond-to-mobile {
      margin-top: 56px;
      max-width: 100%;
    }
  }
}

.seat-select {
  flex-basis: calc(25% - 15px);
  @include respond-to-mobile {
    margin-bottom: 4px;
    box-sizing: border-box;
  }
}

.seat-select + .seat-select {
  @include respond-to-mobile {
    margin-bottom: 4px;
    box-sizing: border-box;
  }
}

.iw-layout-grid-form__row {
  padding: 0px;
  @include respond-to-mobile {
    grid-gap: 16px;
  }
}
</style>
